import { useEffect } from "react";

export default function SEO({ title, description, canonical, image = "/site-images/drive/home-bride.jpg" }) {
  useEffect(() => {
    const url = canonical || window.location.pathname;
    const absolute = url.startsWith("http") ? url : `https://weddingtouch.in${url}`;
    const imageUrl = image.startsWith("http") ? image : `https://weddingtouch.in${image}`;
    document.title = title;
    const setMeta = (selector, attrs) => {
      let el = document.head.querySelector(selector);
      if (!el) { el = document.createElement("meta"); Object.entries(attrs).forEach(([k,v]) => el.setAttribute(k,v)); document.head.appendChild(el); }
      return el;
    };
    setMeta('meta[name="description"]',{name:"description"}).setAttribute("content", description);
    setMeta('meta[property="og:title"]',{property:"og:title"}).setAttribute("content", title);
    setMeta('meta[property="og:description"]',{property:"og:description"}).setAttribute("content", description);
    setMeta('meta[property="og:url"]',{property:"og:url"}).setAttribute("content", absolute);
    setMeta('meta[property="og:image"]',{property:"og:image"}).setAttribute("content", imageUrl);
    setMeta('meta[name="twitter:card"]',{name:"twitter:card"}).setAttribute("content","summary_large_image");
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link=document.createElement("link"); link.rel="canonical"; document.head.appendChild(link); }
    link.href=absolute;
  }, [title, description, canonical, image]);
  return null;
}
